var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('a',{attrs:{"href":"#"}},[_c('span',[_vm._v("© "+_vm._s(this.date)+" kurosawatomonori.com")])])])}
var staticRenderFns = []

export { render, staticRenderFns }